import { gql } from '@apollo/client'

export default gql`
  mutation UpdateChatMessageUnread($ids: [uuid!]!) {
    update_chat_message(_set: { unread: false }, where: { id: { _in: $ids } }) {
      affected_rows
    }
  }
`
